import React, { useRef } from 'react';
import ArticleCard from './ArticleCard';

const ArticleSlider = ({ articles }) => {
  const scrollRef = useRef(null);

  if (!articles || articles.length === 0) return null;

  return (
    <div className="relative w-full overflow-hidden py-4 group">
      <div 
        ref={scrollRef} 
        className="flex gap-6 overflow-x-auto pb-8 snap-x snap-mandatory hide-scrollbar cursor-grab active:cursor-grabbing"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {articles.map((article) => (
          <div 
            key={article.id} 
            className="w-[85vw] sm:w-[320px] md:w-[350px] flex-shrink-0 snap-start"
          >
            <ArticleCard article={article} />
          </div>
        ))}
      </div>
      
      {/* Custom Styles for hiding scrollbar globally if needed, but handled inline above mostly */}
      <style dangerouslySetInnerHTML={{ __html: `
        .hide-scrollbar::-webkit-scrollbar { display: none; }
      `}} />
    </div>
  );
};

export default ArticleSlider;